module.exports = __webpack_public_path__ + "media/images/massage/main_image2@2x-7e7e50b6bd29ae5ad8d8eb8a40f1174e.jpg";